"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchContainer = void 0;
const stitches_config_1 = require("../../../../stitches.config");
exports.SearchContainer = (0, stitches_config_1.styled)("div", {
    position: "fixed",
    zIndex: 15,
    width: "100%",
    envRelativeTop: "0px",
    left: 0,
    padding: "8px",
    "@lg": {
        position: "absolute",
        envRelativeTop: "24px",
        left: "24px",
        width: "500px",
        padding: 0,
    },
    variants: {
        halfMap: {
            true: {
                position: "absolute",
                zIndex: 9,
                envRelativeTop: "68px",
                input: {
                    fontSize: "16px !important",
                },
                "@lg": {
                    position: "fixed",
                    envRelativeTop: "74px",
                    left: "52%",
                    padding: 0,
                },
            },
            false: {
                "@lg": {
                    // eslint-disable-next-line no-restricted-syntax
                    top: "24px",
                },
            },
        },
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGF5ZXJlZE1hcC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL2NvbXBvbmVudHMvTWFwcy9MYXllcmVkTWFwL19fc3R5bGVzX18vTGF5ZXJlZE1hcC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxpRUFBcUQ7QUFFeEMsUUFBQSxlQUFlLEdBQUcsSUFBQSx3QkFBTSxFQUFDLEtBQUssRUFBRTtJQUMzQyxRQUFRLEVBQUUsT0FBTztJQUNqQixNQUFNLEVBQUUsRUFBRTtJQUNWLEtBQUssRUFBRSxNQUFNO0lBQ2IsY0FBYyxFQUFFLEtBQUs7SUFDckIsSUFBSSxFQUFFLENBQUM7SUFDUCxPQUFPLEVBQUUsS0FBSztJQUVkLEtBQUssRUFBRTtRQUNMLFFBQVEsRUFBRSxVQUFVO1FBQ3BCLGNBQWMsRUFBRSxNQUFNO1FBQ3RCLElBQUksRUFBRSxNQUFNO1FBQ1osS0FBSyxFQUFFLE9BQU87UUFDZCxPQUFPLEVBQUUsQ0FBQztLQUNYO0lBRUQsUUFBUSxFQUFFO1FBQ1IsT0FBTyxFQUFFO1lBQ1AsSUFBSSxFQUFFO2dCQUNKLFFBQVEsRUFBRSxVQUFVO2dCQUNwQixNQUFNLEVBQUUsQ0FBQztnQkFDVCxjQUFjLEVBQUUsTUFBTTtnQkFDdEIsS0FBSyxFQUFFO29CQUNMLFFBQVEsRUFBRSxpQkFBaUI7aUJBQzVCO2dCQUVELEtBQUssRUFBRTtvQkFDTCxRQUFRLEVBQUUsT0FBTztvQkFDakIsY0FBYyxFQUFFLE1BQU07b0JBQ3RCLElBQUksRUFBRSxLQUFLO29CQUNYLE9BQU8sRUFBRSxDQUFDO2lCQUNYO2FBQ0Y7WUFDRCxLQUFLLEVBQUU7Z0JBQ0wsS0FBSyxFQUFFO29CQUNMLGdEQUFnRDtvQkFDaEQsR0FBRyxFQUFFLE1BQU07aUJBQ1o7YUFDRjtTQUNGO0tBQ0Y7Q0FDRixDQUFDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBzdHlsZWQgfSBmcm9tIFwiLi4vLi4vLi4vLi4vc3RpdGNoZXMuY29uZmlnXCI7XG5cbmV4cG9ydCBjb25zdCBTZWFyY2hDb250YWluZXIgPSBzdHlsZWQoXCJkaXZcIiwge1xuICBwb3NpdGlvbjogXCJmaXhlZFwiLFxuICB6SW5kZXg6IDE1LFxuICB3aWR0aDogXCIxMDAlXCIsXG4gIGVudlJlbGF0aXZlVG9wOiBcIjBweFwiLFxuICBsZWZ0OiAwLFxuICBwYWRkaW5nOiBcIjhweFwiLFxuXG4gIFwiQGxnXCI6IHtcbiAgICBwb3NpdGlvbjogXCJhYnNvbHV0ZVwiLFxuICAgIGVudlJlbGF0aXZlVG9wOiBcIjI0cHhcIixcbiAgICBsZWZ0OiBcIjI0cHhcIixcbiAgICB3aWR0aDogXCI1MDBweFwiLFxuICAgIHBhZGRpbmc6IDAsXG4gIH0sXG5cbiAgdmFyaWFudHM6IHtcbiAgICBoYWxmTWFwOiB7XG4gICAgICB0cnVlOiB7XG4gICAgICAgIHBvc2l0aW9uOiBcImFic29sdXRlXCIsXG4gICAgICAgIHpJbmRleDogOSxcbiAgICAgICAgZW52UmVsYXRpdmVUb3A6IFwiNjhweFwiLFxuICAgICAgICBpbnB1dDoge1xuICAgICAgICAgIGZvbnRTaXplOiBcIjE2cHggIWltcG9ydGFudFwiLFxuICAgICAgICB9LFxuXG4gICAgICAgIFwiQGxnXCI6IHtcbiAgICAgICAgICBwb3NpdGlvbjogXCJmaXhlZFwiLFxuICAgICAgICAgIGVudlJlbGF0aXZlVG9wOiBcIjc0cHhcIixcbiAgICAgICAgICBsZWZ0OiBcIjUyJVwiLFxuICAgICAgICAgIHBhZGRpbmc6IDAsXG4gICAgICAgIH0sXG4gICAgICB9LFxuICAgICAgZmFsc2U6IHtcbiAgICAgICAgXCJAbGdcIjoge1xuICAgICAgICAgIC8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSBuby1yZXN0cmljdGVkLXN5bnRheFxuICAgICAgICAgIHRvcDogXCIyNHB4XCIsXG4gICAgICAgIH0sXG4gICAgICB9LFxuICAgIH0sXG4gIH0sXG59KTtcbiJdfQ==